/** POST — `apiV8nocache` base is already `/api/v8`. */
const AWARDS_API_PATH = "/pbis/points/awards"
const REDEMPTIONS_API_PATH = "/pbis/points/redemptions"
const CORRECTIONS_API_PATH = "/pbis/points/corrections"

/** How students are chosen on Award / Correction forms. */
const STUDENT_SELECTION_METHOD = Object.freeze({
  MULTISELECT: "multiselect",
  CSV: "csv"
})

const STUDENT_SELECTION_METHOD_VALUES = Object.freeze(
  Object.values(STUDENT_SELECTION_METHOD)
)

const STUDENT_CSV_SAMPLE_PATH =
  "/csv-samples/behaviour-award-students-sample.csv"

export default {
  AWARDS_API_PATH,
  REDEMPTIONS_API_PATH,
  CORRECTIONS_API_PATH,
  STUDENT_SELECTION_METHOD,
  STUDENT_SELECTION_METHOD_VALUES,
  STUDENT_CSV_SAMPLE_PATH
}
